import React from "react";
import ForgotPasswordWidget from "../components/ForgotPasswordWidget";
import AuthTwoColumnedPage from "../components/AuthTwoColumnedPage";

export default function ForgotPasswordPage() {
  return (
    <AuthTwoColumnedPage
      title={
        "Education is a passport to step the world and a key to unlock doors."
      }
      caption={""}
      boxTitle={"Forgot Password"}
      boxCaption={
        "Hello there, we will help you to solve this issue. Follow the steps bellow."
      }
    >
      <ForgotPasswordWidget />
    </AuthTwoColumnedPage>
  );
}
